import { Dispatch } from "redux";
import { setLoading } from "./global";
import { showMessage } from "utilities/helper";
import RaffleService from "service/Raffle";
import { RaffleWinnerPayloadTypes } from "utilities/types/RaffleWinner";

export const getAllRaffleWinners =
  (
    page: number = 1,
    search: string = "",
    limit: number = 10,
    filterCity: string = ""
  ) =>
  async (dispatch: Dispatch) => {
    dispatch(setLoading(true));
    dispatch({
      type: "SET_RAFFLE_WINNER_CURRENT_PAGE",
      currentPage: page,
    });
    dispatch({
      type: "SET_SEARCH_RAFFLE_WINNER",
      searchValue: search,
    });

    try {
      const data = await RaffleService.getAllRaffleWinners(
        page,
        search,
        limit,
        filterCity
      );

      dispatch(setLoading(false));
      dispatch({ type: "SET_RAFFLE_WINNER", value: data.raffle_winners });

      dispatch({
        type: "SET_RAFFLE_WINNER_PAGE",
        totalPage: !!data.raffle_winners.length ? data.last_page : 1,
        limitPage: limit,
        lengthPage: !!data.raffle_winners.length ? data.total_data : 1,
      });
      dispatch({
        type: "SET_RAFFLE_WINNER_FILTER_PAGE",
        filterCityPage: filterCity,
      });
    } catch (err: any) {
      dispatch(setLoading(false));
      if (err.request.status !== 401) {
        console.log("error :", err);
        showMessage(
          !err.response
            ? err.message
            : !!err.response?.data?.error
            ? err.response?.data?.error
            : err.response?.data?.message,
          "error"
        );
      }
    }
  };

export const storeRaffleWinner =
  (form: RaffleWinnerPayloadTypes, handleCloseModal: () => void) =>
  async (dispatch: Dispatch, getState: any) => {
    dispatch({ type: "SET_FORM_LOADING", value: true });
    const payload = form;
    try {
      const data = await RaffleService.storeRaffleWinner(payload);
      const { currentPage, searchValue, limitPage, filterCityPage } =
        getState().raffleWinnerReducer;

      dispatch({ type: "SET_FORM_LOADING", value: false });
      dispatch({ type: "SET_MODAL_FORM", value: false });

      dispatch(
        getAllRaffleWinners(
          currentPage,
          searchValue,
          limitPage,
          filterCityPage
        ) as any
      );

      handleCloseModal();
      showMessage(data.message, "success");
    } catch (err: any) {
      console.log("error :", err);
      dispatch({ type: "SET_FORM_LOADING", value: false });
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  };
